(() => {
  const instances = new WeakMap();

  class CarouselProgress {
    constructor(progress) {
      this.progress = progress;
      this.viewport = document.getElementById(progress.dataset.carouselTarget);
      this.track = progress.querySelector('.sv-carousel-progress__track');
      this.thumb = progress.querySelector('.sv-carousel-progress__thumb');
      this.frame = 0;

      if (!this.viewport || !this.track || !this.thumb) return;

      this.onScroll = () => {
        if (Math.abs(this.viewport.scrollLeft) > 2) this.progress.classList.add('is-engaged');
        this.queue();
      };
      this.onResize = () => this.queue();
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.track);
      this.queue();
    }

    queue() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }

    update() {
      if (!this.viewport || !this.track || !this.thumb) return;
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const hasOverflow = isMobile && max > 2;
      this.progress.hidden = !hasOverflow;
      if (!hasOverflow) return;

      const trackWidth = this.track.clientWidth;
      const visibleRatio = Math.min(1, this.viewport.clientWidth / this.viewport.scrollWidth);
      const thumbWidth = Math.max(30, trackWidth * visibleRatio);
      const ratio = Math.max(0, Math.min(1, Math.abs(this.viewport.scrollLeft) / max));
      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${(trackWidth - thumbWidth) * ratio}px)`;
    }

    destroy() {
      cancelAnimationFrame(this.frame);
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }
  }

  const init = (scope = document) => {
    const candidates = [];
    if (scope.matches?.('[data-sv-carousel-progress]')) candidates.push(scope);
    scope.querySelectorAll?.('[data-sv-carousel-progress]').forEach((node) => candidates.push(node));
    candidates.forEach((node) => {
      if (instances.has(node)) return;
      const instance = new CarouselProgress(node);
      instances.set(node, instance);
    });
  };

  const destroy = (scope) => {
    scope.querySelectorAll?.('[data-sv-carousel-progress]').forEach((node) => {
      instances.get(node)?.destroy();
      instances.delete(node);
    });
  };

  init();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) init(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
